import React, { useRef, useState } from 'react';
import { Avatar } from 'antd';
import { LeftCircleFilled, RightCircleFilled, CoffeeOutlined } from '@ant-design/icons';
import languages from '../services/languageConfig';

const FacilitySlider = ({ facilities = [], facilityData = [], language }) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const sliderRef = useRef(null);

  const filteredFacilities = facilityData.filter(facility => facilities.includes(facility._id));

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -100, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 100, behavior: 'smooth' });
    }
  };

  const handleScroll = () => {
    if (sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '500px',
        paddingTop: '12px',
        display: 'flex',
        justifyContent: 'center',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {showLeftArrow && (
        <div
          onClick={scrollLeft}
          style={{
            position: 'absolute',
            left: '2px',
            top: '33%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: 10,
            borderRadius: '50%',
            padding: '5px',
          }}
        >
          <LeftCircleFilled style={{ color: 'white' }} />
        </div>
      )}

      <div
        ref={sliderRef}
        onScroll={handleScroll}
        style={{
          display: 'inline-flex',
          gap: '15px',
          overflowX: 'auto',
          paddingBottom: '10px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {filteredFacilities.map((facility) => (
          <div key={facility._id} style={{ textAlign: 'center', width: '78px' }}>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <Avatar
                size={56}
                src={facility.avatar}
                style={{
                  border: `2px solid white`,
                }}
              />
              <CoffeeOutlined
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '24px',
                  color: '#fff',
                  borderRadius: '50%',
                  padding: '5px',
                }}
              />
            </div>
            <div
              style={{
                fontFamily: languages[language]?.fontFamily,
                fontSize: languages[language]?.fontSize,
                color: '#fff',
                marginTop: '10px',
                wordBreak: 'break-word',
              }}
            >
              {facility[`name_${language}`]}
            </div>
          </div>
        ))}
      </div>

      {showRightArrow && (
        <div
          onClick={scrollRight}
          style={{
            position: 'absolute',
            right: '2px',
            top: '33%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: 10,
            borderRadius: '50%',
            padding: '5px',
          }}
        >
          <RightCircleFilled style={{ color: 'white' }} />
        </div>
      )}
    </div>
  );
};

export default FacilitySlider;
